export const ORDER_STATUSES = ["en_traitement", "en_production", "en_livraison", "livree"];

export const ORDER_STATUS_LABELS = {
    en_traitement: "En traitement",
    en_production: "En production",
    en_livraison: "En cours de livraison",
    livree: "Livrée",
    annulee: "Annulée",
};

export function statusStyle(status) {
    switch (status) {
        case "en_traitement":
            return { color: "#F2ECE0", border: "rgba(242,236,224,0.4)" };
        case "en_production":
            return { color: "#e5d096", border: "rgba(229,208,150,0.6)" };
        case "en_livraison":
            return { color: "#000", background: "#D4BC7C", border: "#D4BC7C" };
        case "livree":
            return { color: "#A0A0A0", border: "rgba(160,160,160,0.4)" };
        case "annulee":
            return { color: "#fca5a5", background: "rgba(220,38,38,0.08)", border: "rgba(220,38,38,0.5)" };
        default:
            return { color: "#A0A0A0", border: "rgba(160,160,160,0.4)" };
    }
}

export const CANCEL_WINDOW_MS = 15 * 60 * 1000;

/** Milliseconds remaining to cancel/modify this order (0 if already expired or ineligible). */
export function cancelDeadlineMs(order) {
    if (!order || order.status !== "en_traitement" || !order.created_at) return 0;
    try {
        const created = new Date(order.created_at).getTime();
        return Math.max(0, created + CANCEL_WINDOW_MS - Date.now());
    } catch {
        return 0;
    }
}

export function formatOrderRef(id) {
    return `#${(id || "").slice(0, 8).toUpperCase()}`;
}

export function formatCHF(n) {
    return `CHF ${Number(n || 0).toFixed(2)}`;
}
